<template>
    <form @submit.prevent="selectTime" class="container dateTimePickup  min-h-100 d-flex flex-column pt-4 pb-5">
        <div class="row">
            <div class="col-12 descktopMediaBox locationInformation">
                <h2 class="ktdarkchoc">Pickup from</h2>
                <div class="h4">
                    {{business.business_name}}
                </div>
                <div class="address">
                    {{business.address1}}<br/>
                    {{business.city}}, {{business.state}} {{business.zipcode}}
                </div>
                <div class="distBox">
                    <div class="pick">
                        <img :src="getStaticImage('icons/location/bascket.png')">
                        <span>Pickup</span>
                    </div>
                    <div class="dist">
                        {{business.distance}} <span class="descktopMediaBox">miles</span>
                    </div>
                </div>
                <div class="actions">
                    <router-link :to="{name: 'Locations'}">
                        Change Location
                    </router-link>
                </div>
                <div class="botarr"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h2 class="ktdarkchoc">Select a time and date</h2>
                <div>
                    <div class="form-group plDark position-relative">
                        <div class="timeClicker" @click.prevent.stop="showTimeList = !showTimeList">{{timeAm}}</div>
                        <input
                            class="form-control daytimepicker"
                            type="time"
                            :class="{empty: !time}"
                            v-model="time"
                            id="timePicker"
                            placeholder="ASAP"
                            required
                        >
                        <div id="listOfTime" v-if="showTimeList" @click.stop>
                            <div v-for="time in timeList" @click="chooseTime(time)">
                                {{time}}
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="md-field">
                            <md-datepicker v-model="date" required :md-disabled-dates="disabledDates" @md-opened="$refs.mkDatePicker.$el.querySelector('input').blur()" ref="mkDatePicker"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-auto text-center">
            <div class="col-12">
                <div class="toBottom">
                    <div class="ktdarkchoc">Interested in catering?</div>
                    <a class="faq h3" href="https://www.kettlemansbagels.ca/menu/catering/" target="_system">Click here for more info</a>
                    <button class="zbg">
                        continue
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

    import moment from "moment";

    export default {
        name: "DayTimePickup",
        data() {
            return {
                business: null,
                time: null,
                timeAm: null,
                date: null,
                order_time: null,
                now: null,
                dayReadOnly: false,
                timeList: [],
                showTimeList: false,
                addTime: null,
                timeSelected: false,
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "In-Store Pickup", showBackButton: true, showBag: true});
            //this.$store.dispatch("businesses/getBusinessSettings");
            this.business = this.cart.business;
            this.$store.dispatch("menu/getMenuCategories");
        },
        mounted() {

            this.now = moment();

            let addTime = parseInt(this.business.takeout_time) + 3;
            let foundTime = false;

            let day = null

            for (let i = 0; i < 7;) {
                let nowTime = moment().add(addTime, "minutes").add(i, "days");
                day = nowTime.format("ddd");

                //let todayMax = this.business.operation_hours[day.toLowerCase()][0].end;
                let todayMax = "23:55:00";
                
                let date = nowTime.format("YYYY-MM-DD");
                let storeCloseTime = moment(date + ' ' + todayMax, "YYYY-MM-DD HH:mm:ss");

                if (this.business.operation_hours[day.toLowerCase()][0].operation_hours === "Closed" || (!i && nowTime.isAfter(storeCloseTime))) {
                    i++;
                    continue;
                }
                
                //let todayMin = this.business.operation_hours[day.toLowerCase()][0].start;
                let todayMin = "00:00:00";
                let storeOpenTime = moment(date + ' ' + todayMin, "YYYY-MM-DD HH:mm:ss");
                /*console.log("Open tume: "+storeOpenTime.format("HH:mm"));
                console.log("Curent time: "+moment().format("HH:mm"));
                console.log("Time + takeout: "+nowTime.format("HH:mm"));
                console.log("Close Time: "+storeCloseTime.format("HH:mm"));
                console.log("i: "+i);
                console.log("---------------");*/
                if (i || moment().isBefore(storeOpenTime)) {
                    //const todayMin = this.business.operation_hours[day.toLowerCase()][0].start;
                    const todayMin = "00:00:00";
                    let addTime = parseInt(this.business.takeout_time) + 5;
                    let todayMinOrdertime = moment(todayMin, "HH:mm:ss").add(addTime,'minutes').format("HH:mm");
                    this.time = moment(todayMinOrdertime , "HH:mm:ss").format("HH:mm");
                    this.timeAm = moment(todayMinOrdertime, "HH:mm:ss").format("hh:mm A");
                    this.date = moment(date).format("MM/DD/yyyy");
                } else {
                    this.time = this.curentRoundTime().format("HH:mm");
                    this.timeAm = this.curentRoundTime().format("hh:mm A");
                    this.date = moment(date).format("MM/DD/yyyy");
                }
                foundTime = true
                break;
            }


            if (!foundTime) {
                this.$store.commit("shared/setAlert", "this location currently closed");
                this.$router.push({name: 'Locations'})
            }

            //####################################################################
            /*let todayMax = moment(this.business.operation_hours[day.toLowerCase()][0].end, "HH:mm:ss");
            let todayMin = moment(this.business.operation_hours[day.toLowerCase()][0].start, "HH:mm:ss");*/
            let todayMax = moment("23:55:00", "HH:mm:ss");
            let todayMin = moment("00:00:00", "HH:mm:ss");

            document.getElementById("timePicker").max = todayMax.format("HH:mm");
            document.getElementById("timePicker").min = todayMin.format("HH:mm");
            
            let startTime = this.curentRoundTime();
            do {
                this.timeList.push(startTime.format("hh:mm A"))
                startTime.add(5, "minutes");
            } while (todayMax.isAfter(startTime));
            this.timeList.push(startTime.format("hh:mm A"));
        },
        methods: {
            chooseTime(time){
                //console.log(time);
                this.time =  moment(time, "hh:mm A").format("HH:mm");
                this.timeAm =  moment(time, "hh:mm A").format("hh:mm A");
                this.showTimeList = false;
            },
            selectTime() {
                if (this.checkIfStoreOpen()) {
                    this.$store.commit("cart/setOrderTime", this.order_time);
                    this.$store.commit("cart/setAddTime", this.addTime);
                    this.$router.push({name: 'Menu'})
                }
            },
            checkIfStoreOpen() {
                const day = this.date ? moment(this.date).format("ddd") : this.now.format("ddd");
                const date = this.date ? moment(this.date).format("YYYY-MM-DD") : this.now.format("YYYY-MM-DD");
                this.now = moment();

                let order_time = "";
                if (this.business.operation_hours[day.toLowerCase()][0].operation_hours === "Closed") {
                    this.$store.commit("shared/setAlert", "store will be closed that day");
                    return false;
                }

                /*const todayMax = this.business.operation_hours[day.toLowerCase()][0].end;
                const todayMin = this.business.operation_hours[day.toLowerCase()][0].start;*/
                const todayMax = "23:55:00";
                const todayMin = "00:00:00";
                
                order_time = moment(moment(this.date).format("YYYY-MM-DD") + " " + this.time, "YYYY-MM-DD HH:mm").format('YYYY-MM-DD HH:mm:ss')


                const storeCloseTime = moment(date + ' ' + todayMax, "YYYY-MM-DD HH:mm:ss");
                const storeOpenTime = moment(date + ' ' + todayMin, "YYYY-MM-DD HH:mm:ss");


                let allowedTime, allowedError;

                allowedTime = moment(this.now.add(this.business.takeout_time, "minutes"), "HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
                if (this.business.takeout_time > 0) {
                    allowedError = "<h5>You can only schedule order " + this.business.takeout_time + " minutes from now</h5>";
                } else {
                    allowedError = "<h5>You can only schedule order couple minutes from now</h5>";
                }

                this.addTime = this.business.takeout_time;

                if (this.time && moment(order_time).isBefore(allowedTime)) {
                    this.$store.commit("shared/setAlert", allowedError);
                    return false;
                }

                if (moment(order_time).isBefore(storeOpenTime) || moment(order_time).isAfter(storeCloseTime) || moment(order_time).isBefore(moment())) {
                    this.$store.commit("shared/setAlert", "Invalid date");
                    return false;
                }

                if (!this.time && !this.date) {
                    this.order_time = null;
                } else {
                    this.order_time = moment(order_time).format("MM/DD/YY hh:mmA")
                }

                return true;
            },
            disabledDates(date) {
                return new Date(new Date().setDate(new Date().getDate() - 1)) > date;
            },
            calcTime(e) {
                let day = this.date ? moment(this.date).format("ddd") : this.now.format("ddd")
                let addTime = parseInt(this.business.takeout_time) + 3;
                
                /*let todayMax = moment(this.business.operation_hours[day.toLowerCase()][0].end, "HH:mm:ss");
                let todayMin = moment(this.business.operation_hours[day.toLowerCase()][0].start, "HH:mm:ss");*/
                
                let todayMax = moment("23:55:00", "HH:mm:ss");
                let todayMin = moment("00:00:00", "HH:mm:ss");

                document.getElementById("timePicker").max = todayMax.format("HH:mm");
                document.getElementById("timePicker").min = todayMin.format("HH:mm");
                
                
                let startTime = "";
                if(moment(this.now).format("MM/DD/YY") == moment(this.date).format("MM/DD/YY")){
                   startTime = this.curentRoundTime();
                }else{
                    startTime = todayMin
                }

                this.time = startTime.format("HH:mm");
                this.timeAm = startTime.format("hh:mm A");
                
                this.timeList = [];
                do {
                    this.timeList.push(startTime.format("hh:mm A"))
                    startTime.add(5, "minutes");
                } while (todayMax.isAfter(startTime));
                this.timeList.push(startTime.format("hh:mm A"));
            },
            curentRoundTime(){
                let addTime = parseInt(this.business.takeout_time) + 3;
                let nowTime = moment().add(addTime, "minutes")
                let start = moment(nowTime);
                let remainder = 5 - (start.minute() % 5);
                return moment(start).add(remainder, "minutes");
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart;
            }
        },
        watch: {
            date(newVal, oldVal){
                if (oldVal){
                    this.calcTime();
                }
            }
        }
    }
</script>
